// The buyer an express checkout wallet hands over (CIN-15367). Pure: no imports.

/** Who is buying; the same shape as `BuyerDetails` (actions.ts), which a pure module cannot import. */
export type WalletBuyer = { email: string; firstName: string; lastName: string };

/** The wallet's one name field, split the way the buyer modal asks for it: the last word is the last name. */
export function buyerFromWallet(billingDetails: { name?: string; email?: string } | undefined): WalletBuyer {
    const words = (billingDetails?.name ?? '').trim().split(/\s+/).filter(Boolean);
    const lastName = words.length > 1 ? (words.pop() ?? '') : '';
    return { email: billingDetails?.email ?? '', firstName: words.join(' '), lastName };
}
